function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { AppContext } from 'context';
import CheckIcon from 'svg/check.svg';
import XIcon from 'svg/x.svg';
import styles from 'modules/Hcp/components/MergePatientModal/MergePatientModal.pcss';
import * as selectors from '../../selectors';
import messages from '../../messages';
var _React_PureComponent;
class Merging extends (_React_PureComponent = React.PureComponent) {
    componentDidUpdate(prevProps) {
        const { activePatient } = this.props;
        if (prevProps.activePatient !== activePatient) {
            this.props.onClose();
        }
    }
    renderIndicator() {
        const { isInProgress, hasErrors } = this.props;
        if (isInProgress) {
            return /*#__PURE__*/ _jsx("div", {
                className: styles.loaderContainer,
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/assets/svg/loader.svg",
                    className: `${styles.loader} rotatingLoader`,
                    alt: ""
                })
            });
        }
        const Icon = hasErrors ? XIcon : CheckIcon;
        return /*#__PURE__*/ _jsx("div", {
            className: cn(styles.indicatorBackground, {
                [styles.error]: hasErrors
            }),
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.indicator,
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.loaderContainer,
                    children: /*#__PURE__*/ _jsx(Icon, {
                        className: styles.indicatorIcon
                    })
                })
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: "d-flex flex-column align-items-center",
            children: /*#__PURE__*/ _jsx("div", {
                className: "my-4",
                children: this.renderIndicator()
            })
        });
    }
    constructor(props){
        super(props);
        props.onSetHeaderMessage(messages.headers.mergingPatient);
    }
}
_define_property(Merging, "contextType", AppContext);
_define_property(Merging, "propTypes", {
    // Explicit props
    activePatient: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        dateOfBirth: PropTypes.string
    }),
    clinicPatient: PropTypes.shape({
        id: PropTypes.string.isRequired,
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired
    }),
    // Explicit actions
    onSetHeaderMessage: PropTypes.func,
    onClose: PropTypes.func,
    // Implicit props
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool
});
const mapStateToProps = (state)=>({
        isInProgress: selectors.isMergePatientInProgress(state),
        hasErrors: selectors.hasMergePatientErrors(state)
    });
const ConnectedMerging = connect(mapStateToProps)(Merging);
export default ConnectedMerging;
